/**
 * 平板上的 App 共用小组件（我的 › App 管理、日程「从平板上选」都用）：App 图标、搜索框、列表行。
 */
import { LayoutGrid, Search, X } from "lucide-react";
import type { ReactNode } from "react";
import type { DeviceApp } from "../core";
import "./DeviceApps.css";

/** App 图标：data URL；还没上传时显示占位 */
export function AppIcon({ icon, size = 40 }: { icon?: string | null; size?: number }) {
  if (icon) return <img className="dapp-icon" src={icon} alt="" width={size} height={size} loading="lazy" decoding="async" />;
  return (
    <span className="dapp-icon dapp-icon--empty" style={{ width: size, height: size }} aria-hidden>
      <LayoutGrid size={Math.round(size * 0.5)} />
    </span>
  );
}

/** 搜索框（按名称或包名） */
export function AppSearchField({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <label className="dapp-search">
      <Search size={16} strokeWidth={2.4} aria-hidden />
      <input type="search" value={value} onChange={(e) => onChange(e.target.value)} placeholder="搜索名称或包名" aria-label="搜索名称或包名" autoCapitalize="off" autoCorrect="off" spellCheck={false} />
      {value && (
        <button type="button" aria-label="清空" onClick={() => onChange("")}>
          <X size={14} strokeWidth={2.6} />
        </button>
      )}
    </label>
  );
}

/** 一行：图标、名称、第二行文字、右侧内容 */
export function AppRow({ app, subtitle, trailing }: { app: DeviceApp; subtitle: string; trailing?: ReactNode }) {
  return (
    <>
      <AppIcon icon={app.icon} />
      <span className="dapp-text">
        <strong>{app.label}</strong>
        <small title={subtitle}>{subtitle}</small>
      </span>
      {trailing}
    </>
  );
}
